import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bienvenue " + (u.first_name || u.name));
      navigate(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : Array.isArray(detail) ? detail.map(e => e.msg).join(" ") : "Connexion échouée";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <p className="font-accent text-3xl text-terracotta -rotate-2 mb-2 text-center">Bon retour</p>
      <h1 className="font-serif-display text-4xl mb-10 text-center">Connexion</h1>
      <form onSubmit={submit} className="bg-white/70 backdrop-blur-md rounded-3xl border border-[#E5E1D8] p-8 space-y-4">
        <div>
          <label htmlFor="login-email" className="block text-sm text-[#6B655C] mb-1.5">Adresse e-mail</label>
          <input id="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" className="w-full p-3 rounded-2xl border border-[#E5E1D8] focus:outline-none focus:border-terracotta" data-testid="login-email" />
        </div>
        <div>
          <label htmlFor="login-password" className="block text-sm text-[#6B655C] mb-1.5">Mot de passe</label>
          <div className="relative">
            <input id="login-password" required type={showPw ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Votre mot de passe" className="w-full p-3 pr-11 rounded-2xl border border-[#E5E1D8] focus:outline-none focus:border-terracotta" data-testid="login-password" />
            <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6B655C] hover:text-terracotta" data-testid="toggle-password">
              {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>
        <div className="text-right">
          <Link to="/forgot-password" className="text-sm text-terracotta hover:underline" data-testid="forgot-password-link">Mot de passe oublié ?</Link>
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-50" data-testid="login-submit-btn">
          {loading ? "Connexion..." : "Se connecter"}
        </button>
      </form>
      <p className="text-center text-sm text-[#6B655C] mt-6">
        Pas encore de compte ?{" "}
        <Link to="/register" className="text-terracotta hover:underline" data-testid="goto-register">Créer un compte</Link>
      </p>
    </div>
  );
}
